"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../composite/table/table-cells");
const table_filter_cells_1 = require("../../composite/table/table-filter-cells");
const translations_api_1 = require("./translations-api");
function useColumns() {
    const intl = (0, react_intl_1.useIntl)();
    return [
        {
            datakey: 'language',
            sortkey: 'language.name',
            filterkey: 'language.id',
            name: intl.formatMessage({
                id: 'EAS_TRANSLATIONS_COLUMN_LANGUAGE',
                defaultMessage: 'Jazyk',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(translations_api_1.useLanguages),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(translations_api_1.useLanguages),
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=translations-columns.js.map